import React from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { LoaderIcon } from "../../../../../utils/svg";
import {
  sendAnalyticsCustomEvent,
  trackMetaPixelEvent
} from "../../../../../utils/helper";
import { useSelector } from "react-redux";

const PaymentOption = ({
  isLoadingPaymentMethodList = false,
  values = {},
  setIsShowPaymentMethod = () => {},
  setIsShowBottomSheet = () => {}
}) => {
  const user = useSelector((store) => store?.user);
  const hideMethod =
    user?.is_b2b &&
    (user?.paymentMethod?.toLowerCase() === "direct" ||
      user?.companyName?.toLowerCase() === "bri");
  return (
    <div className={`mx-4 mt-4 ${hideMethod ? "hidden" : ""}`}>
      <div className="text-gray-900 text-sm font-semibold">
        Metode Pembayaran
      </div>
      <div
        id="summary_view_payment_methods"
        className={`mt-2 border-solid border-1 border-gray-300 rounded-lg px-4 py-2 flex justify-between items-center min-h-14`}
        onClick={() => {
          if (isLoadingPaymentMethodList) return;
          setIsShowPaymentMethod(true);
          setIsShowBottomSheet(true);
          sendAnalyticsCustomEvent("summary_topup_ultra_value");
          trackMetaPixelEvent("summary_topup_ultra_value");
        }}
      >
        {isLoadingPaymentMethodList ? (
          <div className="flex justify-center items-center w-full h-full">
            <LoaderIcon />
          </div>
        ) : (
          <>
            <div className="flex items-center">
              <div className="pl-2">
                <div className="text-gray-700 text-xs font-thin">
                  {values?.paymentType?.name ?? ""}
                </div>
              </div>
            </div>
            <ChevronRightIcon
              className="h-4 w-4 text-gray-800"
              strokeWidth={3}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentOption;